var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1728 11.3234L10.3867 8.56021C10.145 8.42068 9.84719 8.42068 9.60547 8.56021C9.36375 8.69975 9.21484 8.95763 9.21484 9.23677V14.7632C9.21484 15.0423 9.36375 15.3002 9.60547 15.4398C9.84723 15.5793 10.1449 15.5794 10.3867 15.4398L15.1728 12.6765C15.4145 12.537 15.5634 12.2791 15.5634 12C15.5634 11.7209 15.4145 11.463 15.1728 11.3234ZM10.7773 13.4101V10.5899L13.2197 11.9999L10.7773 13.4101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6009 16.7586C21.2484 18.8503 19.7043 20.4614 17.7588 20.7677C13.8994 21.3751 10.0245 21.3631 6.24122 20.7677C4.29567 20.4614 2.75165 18.8503 2.39911 16.7586C1.86696 13.601 1.86696 10.3989 2.39911 7.24141C2.75165 5.14965 4.29567 3.53848 6.24122 3.2323C10.0625 2.6309 13.9375 2.6309 17.7588 3.2323C19.7043 3.53852 21.2484 5.14965 21.6009 7.24141C22.1331 10.399 22.1331 13.601 21.6009 16.7586ZM20.0599 7.50117C19.8191 6.07285 18.7968 4.97777 17.5158 4.77613C13.8559 4.20008 10.144 4.20008 6.48423 4.77613C5.20325 4.97773 4.18091 6.07285 3.94021 7.50117C3.43708 10.4864 3.43708 13.5136 3.94021 16.4988C4.18091 17.9271 5.20329 19.0221 6.48423 19.2238C10.1442 19.7999 13.8558 19.7998 17.5159 19.2238C18.7968 19.0222 19.8192 17.9271 20.0599 16.4988C20.5629 13.5136 20.5629 10.4864 20.0599 7.50117Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestData);
export default __webpack_public_path__ + "static/media/test-data.ffba9124bf1b598674b2be3bac855e75.svg";
export { ForwardRef as ReactComponent };